export const extraServiceData = [
  {
    img: "/assets/images/extra-service/warranty-service.png",
    title: "2 Years Warranty",
    content:
      "Our 2-year warranty offers dependable coverage, protecting your purchase against manufacturing defects and unexpected issues. With this feature, you can enjoy peace of mind, knowing that your product is backed by our commitment to quality and reliability for a full two years.",
  },
  {
    img: "/assets/images/extra-service/replacement-service.png",
    title: "30 Day Replacement",
    content:
      "Our 30-day replacement feature gives you peace of mind by allowing you to replace your purchase within 30 days if it has any defects or issues. This guarantee ensures that you have ample time to check your product’s quality, so you can shop confidently knowing that we’re committed to your satisfaction.",
  },
  {
    img: "/assets/images/extra-service/customer-service.png",
    title: "Life Time Customer Service",
    content:
      "Our Lifetime Support service provides you with continuous assistance for as long as you own your product. This feature ensures expert guidance, troubleshooting, and answers to any questions you may have at any stage, so you can feel secure knowing help is always just a call or message away.",
  },
];

export const extraServiceReturnOptions = {
  main_title: "Return Option",
  sub_content:
    "Essentially, PC Worth’s return option is a defect-based policy focused on replacements within a limited time frame, with strict conditions on packaging, item condition, and verification requirements",
  data: [
    {
      title: "Defective Product Returns",
      content:
        "Customers can return items that are proven to have factory defects. The process involves sending the item to PC Worth’s Technical Support team for evaluation to confirm the defect",
      bullets: [],
    },
    {
      title: "30-Day Replacement",
      content:
        "Customers can return items that are proven to have factory defects. The process involves sending the item to PC Worth’s Technical Support team for evaluation to confirm the defect",
      bullets: [
        "The item is in good physical condition",
        "All original accessories, manuals, and packaging are included and intact",
        "The defect is verified by Technical Support",
      ],
    },
    {
      title: "Physical Damage and Time Restrictions",
      content:
        "Customers can return items that are proven to have factory defects. The process involves sending the item to PC Worth’s Technical Support team for evaluation to confirm the defect",
      bullets: [],
    },
    {
      title: "No Return on Non-Defective Items",
      content:
        "PC Worth does not allow returns for items without confirmed defects. Additionally, cash refunds are not available under this policy",
      bullets: [],
    },
  ],
};

export const termsAndConditionsData = {
  main_title: "Terms & Conditions",
  sub_content:
    "The warranty terms and conditions for PC Worth cover several essential aspects, including eligibility, exclusions, and guidelines for customers.",
  sub_footer_content:
    "These terms highlight the need for customers to keep all documentation, use products responsibly, and understand the limits of what’s covered.",
  data: [
    {
      title: "Eligibility for Warranty Claims",
      bold_text: [],
      bullets: [
        "A warranty slip or a Product Warranty record (available in the user’s online account) is required to claim a warranty",
        "If the warranty slip is missing, the product’s original box with an intact serial number may be accepted.",
        "Items returned must have an intact serial number and warranty sticker",
      ],
    },
    {
      title: "Warranty Coverage",
      bold_text: [
        "Warranty Period:",
        "Monitor Warranty: ",
        "Laptop Warranty:",
        "Service and Repairs:",
      ],
      bullets: [
        "Starts from the date of purchase and is recorded on both the warranty slip and online warranty menu for registered users.",
        "Claims are eligible for monitors with six or more dead pixels and must include the original box, accessories, stand, and Styrofoam.",
        "Covers hardware defects in components like the processor, RAM, storage, display, and power adapter. Software issues and damage due to misuse are not covered.",
        "PC Worth provides free warranty repairs in-store for qualifying defects. The warranty excludes software issues and does not cover data loss for storage devices. It also excludes on-site service.",
      ],
    },
    {
      title: "Warranty Exclusions",
      bold_text: [
        "Physical or Environmental Damage:",
        "Compatibility:",
        "Excluded Items:",
        "User-Modified Items:",
      ],
      bullets: [
        "Warranty is void if there’s physical damage, liquid damage, unauthorized modifications, pest infestation, misuse, or environmental damage (e.g., corrosion, burns).",
        "Customers are responsible for ensuring compatibility. PC Worth is not liable for issues arising from incompatible components.",
        "Software, consumables, freebies, and modified printers or GPUs used for mining are not covered.",
        "Any item tampered with or modified outside of authorized service will void the warranty.",
      ],
    },
    {
      title: "Return and Replacement Process",
      bold_text: [],
      bullets: [
        "Defective items must be evaluated by Technical Support. Products returned within 30 days may qualify for a replacement if they meet all conditions.",
        "No Return Policy: Items can only be returned if proven defective; otherwise, no returns are allowed.",
        "Replacement for Phased-Out Products: If a defective product is phased out, PC Worth may offer a similar product or model based on current market value or request additional payment if an upgrade is required.",
      ],
    },
    {
      title: "Claiming and Storage Fees",
      bold_text: [],
      bullets: [
        "Customers must claim their warranty items within 30 days of receiving notice; otherwise, a storage fee applies. After 90 days, unclaimed items may be disposed of by PC Worth.",
      ],
    },
    {
      title: "Liabilities and Limitations",
      bold_text: [],
      bullets: [
        "PC Worth and its suppliers are not liable for incidental or consequential damages, including lost savings or profits.",
        "Customers are responsible for all shipping costs associated with warranty claims.",
      ],
    },
    {
      title: "Agreement to Terms",
      bold_text: [],
      bullets: [
        "Online purchases automatically imply agreement to the warranty terms and conditions without a signature, as stated at checkout.",
      ],
    },
  ],
};

export const faqData = [
  {
    question: "What documents do I need to claim a warranty for my product?",
    content:
      "You need to present either your warranty slip issued by PC Worth or the Product Warranty record available in your online account. If you’ve lost the warranty slip, you may use the product’s original box with an intact serial number and barcode.",
    bullets: [],
  },
  {
    question: "What products are eligible for a return or replacement?",
    content:
      "Only products with factory defects, confirmed by PC Worth’s Technical Support, are eligible for return or replacement. To qualify for replacement, the defective item must be returned within 30 days from the purchase date, in good condition, with all accessories, manuals, and original packaging.",
  },
  {
    question: "Can I return a product if I simply change my mind?",
    content:
      "No, PC Worth has a No Return Policy for non-defective items. Returns are only accepted for products verified as defective by Technical Support.",
    bullets: [],
  },
  {
    question: "What items or damages are not covered by the warranty?",
    content: "The warranty does not cover:",
    bullets: [
      "Physical or environmental damage (e.g., burns, corrosion, bent pins, pest infestation).",
      "Software issues, viruses, or software incompatibility.",
      "Items altered, tampered with, or used for purposes like mining.",
      "Modified printers with continuous ink systems or refillable inks.",
      "Consumables, freebies, or promotional items.",
    ],
  },
  {
    question: "My monitor has dead pixels. Is it covered under warranty?",
    content:
      "Yes, if your monitor has six or more dead pixels. Monitors with fewer than six dead pixels are considered functional and are not eligible for warranty claims.",
    bullets: [],
  },
  {
    question: "How long is my warranty valid, and when does it start?",
    content:
      "The warranty period begins on the date of purchase and is indicated on the warranty slip and the Product Warranty record in your online account. Make sure to keep these records for reference.",
    bullets: [],
  },
  {
    question: "What should I bring when claiming a laptop or monitor warranty?",
    content: "When claiming a warranty for a laptop or monitor, bring:",
    bullets: [
      "The original box with all packaging (including Styrofoam).",
      "Accessories (stand, power adapter, etc.).",
      "Receipt and warranty slip.",
    ],
  },
  {
    question: "Are software-related issues covered by the warranty?",
    content:
      "No, software issues, including viruses, operating system errors, and compatibility problems, are not covered. PC Worth only covers hardware defects.",
    bullets: [],
  },
  {
    question: "Who is responsible for shipping costs for warranty claims?",
    content:
      "Customers are responsible for all shipping costs related to warranty claims.",
    bullets: [],
  },
  {
    question: "Can I get a cash refund for a defective product?",
    content:
      "No, PC Worth does not offer cash refunds. Defective products can be repaired or replaced based on Technical Support’s evaluation.",
    bullets: [],
  },
  {
    question:
      "What happens if the product I need replaced is no longer available?",
    content:
      "If your product is phased out, PC Worth may offer an alternative brand or model based on the current market value or the original purchase price, whichever is lower. If an upgrade is requested, PC Worth may require an additional payment with the customer’s agreement.",
    bullets: [],
  },
  {
    question: "Is there a deadline for picking up my warranty-repaired items?",
    content:
      "Yes. Warranty items must be picked up within 30 days from the notice. After that, a storage fee of 50 pesos per day applies. If unclaimed within 90 days, items may be disposed of by PC Worth.",
    bullets: [],
  },
  {
    question:
      "Does purchasing online mean I automatically agree to the warranty terms?",
    content:
      "Yes, by completing an online purchase, you agree to all warranty terms and conditions as listed on PC Worth’s website.",
    bullets: [],
  },
];
